import { apiAuthClient } from 'shared/api/lib/apiAuthClient';

import type { PostBoardRequest, PostBoardResponse } from '../types';

export const postBoard = async ({
  pathParams: { organisationId },
  bodyParams,
}: PostBoardRequest) => {
  const url = `/api/v2/organisations/${organisationId}/boards`;
  const { data } = await apiAuthClient.post<PostBoardResponse>(url, bodyParams);
  return data.data;
};
